import { List } from 'immutable'

export type ExpandBlockState = List<boolean>

export const initialExpandBlockState = (length: number) => List(Array.from({ length: length }, () => false))

export const expandBlockStateUpdaters = {
  expandBlockItemUpdater:
    (index: number) =>
    (currentState: ExpandBlockState): ExpandBlockState =>
      currentState.set(index, !currentState.get(index)),
}
